import {
  APPLICATION_ID as CARINA_APPLICATION_ID,
  COCOPLUS_APPLICATION_ID,
  CORUN_APPLICATION_ID,
  HIBANA_APPLICATION_ID,
} from "~/constants/app";
import { getCurrentApplicationId } from "~/lib/applicationId";
import { sendGa4Event } from "~/lib/ga4";
import { postMessageToNative } from "~/lib/webview";
import type { FirebaseEventParams } from "./types";

/**
 * Firebase Analytics 送信対象の applicationId（ネイティブ側 FirebaseMessageHandler 実装済みのアプリのみ）
 * Carina=95 / HIBANA=132 / coco+=145 / CORUN=148
 */
const FIREBASE_TRACKING_APPLICATION_IDS = new Set([
  CARINA_APPLICATION_ID,
  HIBANA_APPLICATION_ID,
  COCOPLUS_APPLICATION_ID,
  CORUN_APPLICATION_ID,
]);

/**
 * Firebase Analytics へイベントを送信する低レベル bridge（Carina=95 / HIBANA=132 / coco+=145 / CORUN=148 限定）。
 * ネイティブ側 FirebaseMessageHandler が Analytics.logEvent へ転送する。
 *
 * 直接呼ばず、source が自動付与される trackFirebaseEvent / trackFirebaseScreenView を使うこと。
 */
export const sendFirebaseEvent = (
  eventName: string,
  params: FirebaseEventParams,
): void => {
  // Sakura / Renka Android 等ネイティブ未対応アプリは GA4 Web へ直送（対象外アプリでは no-op）
  sendGa4Event(eventName, params);

  // 直後に WebView が破棄される経路で落ちないよう同期で送る
  try {
    if (!FIREBASE_TRACKING_APPLICATION_IDS.has(getCurrentApplicationId())) {
      return;
    }

    postMessageToNative({
      type: "FIREBASE_TRACK_EVENT",
      payload: { eventName, params },
    });
  } catch {
    // 補助機能のため例外は握りつぶす
  }
};
